<template lang="html">
  <section
    v-if="links.length"
    class="category-popular-links"
    aria-label="Популярные категории"
  >
    <h2 class="mb-3 text-sm font-medium text-muted">
      Популярное
    </h2>
    <ul class="flex flex-wrap gap-x-4 gap-y-2">
      <li
        v-for="link in links"
        :key="link.id"
      >
        <NuxtLink
          :to="link.to"
          class="text-sm text-highlighted underline-offset-4 hover:underline focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
        >
          {{ link.label }}
        </NuxtLink>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
/**
 * Optional popular / quick links strip (S13, P1).
 * Renders nothing when `links` is empty — omit the section entirely.
 * Callers must resolve each link via the shared destination resolver.
 */
export type CategoryPopularLink = {
  id: number | string
  label: string
  to: string
}

defineProps<{
  links: CategoryPopularLink[]
}>()
</script>
